import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  isAdminSelector,
  isManagerSelector,
  devicesSelector,
  itemsSelector,
  pathSelector,
  channelsSelector,
  deviceModelsSelector,
  coverAttachmentByModelIdSelector,
} from '../selectors';
import { openDeviceAddModal, fetchSite, deleteDevice, updateDeviceCommon } from '../actions/entry';
import Devices from '../components/Devices';

const mapStateToProps = (state) => {
  const { deviceId } = pathSelector(state);
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);
  let devices = devicesSelector(state);
  const items = itemsSelector(state);
  const channels = channelsSelector(state);
  const models = deviceModelsSelector(state);

  devices = devices.map((device) => {
    const attachment = coverAttachmentByModelIdSelector(state, device.modelId);
    return {
      attachment,
      ...device,
    };
  });

  return {
    channels,
    models,
    items,
    devices,
    canView: isAdmin || isManager,
    canEdit: isAdmin,
    isDeviceModalOpened: !!deviceId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSiteFetch: fetchSite,
      onAdd: openDeviceAddModal,
      onUpdate: (data) => updateDeviceCommon(data.id, data),
      onDelete: (data) => deleteDevice(data.id),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Devices);
